module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"search":"Restaurant Name, Cuisine, Location"},"th":{"search":"ชื่อร้านอาหาร, ประเภท, สถานที่"}}')
  delete Component.options._Ctor
}
